import { render, staticRenderFns } from "./MenuAprovacao.vue?vue&type=template&id=f68c9e6a&"
import script from "./MenuAprovacao.vue?vue&type=script&lang=js&"
export * from "./MenuAprovacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports